import React from "react"
import { COMPANIES } from "./constants"
import CdFinanceMapDetail from "./CdFinanceMapDetail"
import CropinMapDetail from "./CropinMapDetail"
import KimDentalMapDetail from "./KimDentalMapDetail"
import SunseapMapDetail from "./SunseapMapDetail"
import V2FoodMapDetail from "./V2FoodMapDetail"

const MapDetail = props => {
  return (
    <>
      {props.currentlySelectedCompany === COMPANIES.cropIn && (
        <CropinMapDetail />
      )}
      {props.currentlySelectedCompany === COMPANIES.cdFinance && (
        <CdFinanceMapDetail />
      )}
      {props.currentlySelectedCompany === COMPANIES.kimDental && (
        <KimDentalMapDetail />
      )}
      {props.currentlySelectedCompany === COMPANIES.sunseap && (
        <SunseapMapDetail />
      )}
      {props.currentlySelectedCompany === COMPANIES.v2Food && (
        <V2FoodMapDetail />
      )}
    </>
  )
}

export default MapDetail
